import React, { useState, useEffect } from 'react';
import API from '../utils/axios';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Award } from 'lucide-react';

export const Winners = () => {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await API.get('/winners');
        setWinners(data);
      } catch (e) {
        // silent
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="App">
      <Header />

      <section className="py-24 container mx-auto px-4 min-h-screen">
        <div className="text-center mb-12">
          <Award className="inline-block text-[#FFD60A] mb-4" size={64} />
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tight" data-testid="winners-title">
            Pemenang
          </h1>
          <p className="text-gray-400 text-lg">Daftar pemenang beruntung EXTRA TIME</p>
        </div>

        <div className="max-w-5xl mx-auto">
          {loading ? (
            <div className="text-center py-12 text-gray-400">Loading...</div>
          ) : winners.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-400 text-lg">Belum ada pemenang diumumkan</p>
            </div>
          ) : (
            <div className="glass-card overflow-hidden">
              <div className="w-full">
                <table className="w-full table-fixed" data-testid="winners-table">
                  <thead className="bg-white/5 border-b border-white/10">
                    <tr>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-left text-xs md:text-sm font-bold text-white w-[18%]">Rank</th>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-left text-xs md:text-sm font-bold text-white w-[27%]">Website</th>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-left text-xs md:text-sm font-bold text-white w-[27%]">User ID</th>
                      <th className="px-2 md:px-6 py-3 md:py-4 text-left text-xs md:text-sm font-bold text-white w-[28%]">Hadiah</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white/10">
                    {winners.map((w) => (
                      <tr key={w.id} className="hover:bg-white/5 transition-colors" data-testid={`winner-row-${w.id}`}>
                        <td className="px-2 md:px-6 py-3 md:py-4">
                          <div className="flex items-center gap-1 md:gap-2">
                            {w.rank && w.rank <= 3 && (
                              <Award className={`hidden sm:inline shrink-0 ${
                                w.rank === 1 ? 'text-[#FFD60A]' :
                                w.rank === 2 ? 'text-gray-300' : 'text-[#CD7F32]'
                              }`} size={18} />
                            )}
                            <span className={`font-black text-sm md:text-lg ${
                              w.rank === 1 ? 'text-[#FFD60A]' :
                              w.rank === 2 ? 'text-gray-300' :
                              w.rank === 3 ? 'text-[#CD7F32]' : 'text-white'
                            }`}>
                              {w.rank ? `#${w.rank}` : '-'}
                            </span>
                          </div>
                        </td>
                        <td className="px-2 md:px-6 py-3 md:py-4 text-white text-xs md:text-base font-medium break-words">{w.website || '-'}</td>
                        <td className="px-2 md:px-6 py-3 md:py-4 text-white text-xs md:text-base font-mono break-all">{w.user_id}</td>
                        <td className="px-2 md:px-6 py-3 md:py-4 text-white text-xs md:text-base font-semibold break-words">{w.prize || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};
